import { captureException } from '@sentry/angular';
import { isSentryEnabled } from './sentry-init';

export function captureSentryException(error: unknown): void {
  if (!isSentryEnabled()) {
    return;
  }
  try {
    captureException(error);
  } catch {
    // Monitoring must never break the app.
  }
}
